<form #f="ngForm" style="width: 100%;">

  @if (detail.id) {
    <div class="grid fluid" style="margin: 0 0 30px 0">
      <div class="col-12">
        <p-message severity="info">
          <i class="fa fa-solid fa-circle-info mx-2"></i>
          <span i18n="@@confirmations-confirm_action">Confirm the action:</span>
          @if (detail.type) {
            <strong class="ml-2">{{ utilitiesService.getLocalisedLookup(detail.type, CONFIRMATION_TYPES) }}</strong>
          }
        </p-message>
      </div>
      @if ([ConfirmationType.ASSET_ASSIGN, ConfirmationType.ASSET_UNASSIGN, ConfirmationType.ASSET_TRANSFER_PREMISES].includes(detail.type!)) {
        <div class="col-4">
          <div class="field-label" i18n="@@assets-category">Category</div>
          <div class="form-field">{{ utilitiesService.getLocalisedLookup(detail.content?.asset?.category, LOGISTICS_ASSET_CATEGORIES) }}</div>
        </div>
        <div class="col-4">
          <div class="field-label" i18n="@@assets-sub_category">Sub category</div>
          <div class="form-field">{{ utilitiesService.getLocalisedLookup(detail.content?.asset?.sub_category, LOGISTICS_ASSET_SUB_CATEGORIES) }}</div>
        </div>
        <div class="col-4">
          <div class="field-label" i18n="@@assets-brand">Brand</div>
          <div class="form-field">{{ detail.content?.asset?.brand }}</div>
        </div>
        <div class="col-4">
          <div class="field-label" i18n="@@assets-model">Model</div>
          <div class="form-field">{{ detail.content?.asset?.model }}</div>
        </div>
        <div class="col-4">
          <div class="field-label" i18n="@@assets-condition">Condition</div>
          <div class="form-field">{{ utilitiesService.getLocalisedLookup(detail.content?.asset?.condition, LOGISTICS_ASSET_CONDITIONS) }}</div>
        </div>
        <div class="col-4">
          <div class="field-label" i18n="@@assets-accessories">Accessories</div>
          <div class="form-field">
            @for (accessory of detail.content?.asset?.accessories; track accessory) {
              <p-tag class="mr-1">
                {{ utilitiesService.getLocalisedLookup(accessory, LOGISTICS_ASSET_ACCESSORIES) }}
              </p-tag>
            }
          </div>
        </div>
      }
      @if (detail.type === ConfirmationType.ASSET_TRANSFER_PREMISES && isAllocationPremises(detail.content)) {
        <p-divider class="col-12"></p-divider>
        <div class="col-6">
          <div class="field-label" i18n="@@assets_allocations_premises-from">From</div>
          <div class="form-field">
            {{ detail.content.asset?.current_premises?.code }}
            ({{ detail.content.asset?.current_premises?.place?.name }})
          </div>
        </div>
        <div class="col-6">
          <div class="field-label" i18n="@@assets_allocations_premises-to">To</div>
          <div class="form-field">
            {{ detail.content.premises?.code }}
            ({{ detail.content.premises?.place?.name }})
          </div>
        </div>
      }
      @if (!methodMustBeCore()) {
        <p-divider class="col-12" />
        @if ((detail.confirmation_staff_relations?.length || 0) > 0) {
          <div class="col-12">
            <div class="field-label" i18n="@@confirmations-user">User</div>
            <div class="fake-field">
              <ul>
                @for (staffRelation of detail.confirmation_staff_relations; track staffRelation) {
                  <li>{{ staffRelation.confirming_staff.display_name }}</li>
                }
              </ul>
            </div>
          </div>
        }
        <div class="col-12">
          <div class="field-label" i18n="@@confirmations-method">Confirmation method</div>
          <p-select [(ngModel)]="method" name="method" [showClear]="true" appendTo="body"
            [required]="true" class="acted-highlight-req form-field full-width"
            [options]="confirmationMethods" [optionLabel]="labelField" optionValue="value"
            placeholder="(none)" i18n-placeholder="@@common-none">
          </p-select>
        </div>
      }
      @if (detail.type === ConfirmationType.ASSET_ASSIGN && [ConfirmationMethod.CORE_USER, ConfirmationMethod.DRAWING].includes(method!)) {
        <div class="col-12">
          <div class="field-label" i18n="@@confirmations-asset_assign_agreement">
          I, the undersigned, have read and agreed to the following:
          <ol>
            <li>The Recipient is responsible for the integrity of the asset handed over to him or her;</li>
            <li>In case the assets are lost, the Recipient will be held responsible and may have to reimburse the original price of the asset;</li>
            <li>In case the assets are damaged due to carelessness, the Recipient will be charged for repair costs;</li>
            <li>Repair and maintenance of the assets will be handled by technical staff; the Recipient should not attempt any repair by himself or herself;</li>
            <li>The Recipient is obliged to return the assets to the Acted/IMPACT logistics department at the end of his or her contract.</li>
          </ol>
        </div>
        </div>
      }
      @if (method === ConfirmationMethod.DRAWING) {
        <div class="col-12">
          @if (detail.type === ConfirmationType.ASSET_ASSIGN) {
            <div class="field-label" i18n="@@confirmations-asset_assign_signature">Signature by the assignee:</div>
          }
          <canvas #drawingCanvas width="30rem" height="30rem"
            class="acted-highlight-req form-field full-width bg-white">
          </canvas>
        </div>
      }
      @if (method === ConfirmationMethod.AST_04) {
        <div class="col-12">
          <div class="field-label" i18n="@@attachments-file">File</div>
          <p-fileupload #fileInput name="theFile[]" [customUpload]="true" [showUploadButton]="false"
            [showCancelButton]="false" [multiple]="true" class="full-width"
            [maxFileSize]="100000000" i18n-chooseLabel="@@common-add" chooseLabel="Add">
            <ng-template let-file pTemplate="file">
              <div><b>{{file.name}}</b>: ({{file.size}} bytes)</div>
            </ng-template>
          </p-fileupload>
        </div>
      }
      <p-divider class="col-12"></p-divider>
      @if (![ConfirmationType.ASSET_ASSIGN, ConfirmationType.ASSET_UNASSIGN].includes(detail.type!)) {
        <div class="col-12">
          <div class="field-label" i18n="@@confirmations-reject_reason">Rejection reason</div>
          <textarea pTextarea [autoResize]="false" [(ngModel)]="detail.rejection_reason" name="rejection_reason"
            class="form-field full-width">
          </textarea>
        </div>
      }
    </div>
  }

  <div style="margin-bottom: 20px; text-align: right">
    <div class="field-label">
      <p-button icon="fa fa-solid fa-xmark" i18n-label="@@common-cancel" label="Cancel" (onClick)="onCancel()"
      styleClass="p-button-secondary"></p-button>
      @if (![ConfirmationType.ASSET_ASSIGN, ConfirmationType.ASSET_UNASSIGN].includes(detail.type!)) {
        <p-button icon="fa fa-regular fa-floppy-disk" i18n-label="@@confirmations-reject" label="Reject" (onClick)="onReject()"
          [disabled]="!detail.rejection_reason" styleClass="p-button-danger ml-1" [loading]="loading"
        ></p-button>
      }
      @if (method !== ConfirmationMethod.DRAWING) {
        <p-button icon="fa fa-regular fa-floppy-disk" i18n-label="@@confirmations-accept" label="Accept" (onClick)="onAccept()"
          [disabled]="!detailForm.valid" styleClass="p-button-success ml-1" [loading]="loading"
        ></p-button>
      }
      @if (method === ConfirmationMethod.DRAWING) {
        <p-button icon="fa fa-solid fa-signature" i18n-label="@@confirmations-sign" label="Sign" (onClick)="onAccept()"
          [disabled]="!detailForm.valid || signaturePad?.isEmpty()" styleClass="p-button-success ml-1" [loading]="loading"
        ></p-button>
      }
    </div>
  </div>

</form>
